module.exports = __webpack_public_path__ + "assets/img/emailIcon.ac194ac3.png";